import { render, staticRenderFns } from "./creat-image.vue?vue&type=template&id=7c89195c&scoped=true"
import script from "./creat-image.vue?vue&type=script&lang=js"
export * from "./creat-image.vue?vue&type=script&lang=js"
import style0 from "./creat-image.vue?vue&type=style&index=0&id=7c89195c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c89195c",
  null
  
)

export default component.exports